import * as service from './service'
export default {
  namespace: 'walletAccountLogoff',
  state: {
    demoData: {}
  },
  effects: {
    * queryPrepareCancelTimeText ({ payload }, { call, put }) {
      const res = yield call(service.queryPrepareCancelTimeText, payload)
      return res.data
    },

    * queryCourierStatus ({ payload }, { call, put }) {
      const res = yield call(service.queryCourierStatus, payload)
      return res.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
